<template>
	<div>
		<Overlay
			:position="'absolute'"
			:open="loading"
			:color="''"
			:maxOpacity="1"
			:classes="'loader'"
		>
			<div v-if="loading">
				<!-- <div class=" position-fixed"></div> -->
			</div>
		</Overlay>
		
		<div v-if="isDisplayApp" class="container px-0 reviewsApp">
			<Reviews />
		</div>
	</div>
</template>

<script>

import { mapState } from "vuex";

// components
import Reviews from "@/vue/reviews/components/reviews.vue";
import Overlay from "@/vue/common/overlay.vue";

export default {
	
	name: "ReviewsApp",
	components: {
		Reviews,
		Overlay,
	},

	computed: {
		...mapState(["loading", "feature", "ssrReviewData"]),

		isDisplayApp() {
			const hasReviews = this.ssrReviewData?.reviews?.length > 0
			return hasReviews;
		},
	},

	async mounted() {
		if (!this.isDisplayApp) {
				const ssrEl = document.querySelector('#reviews-ssr')
    		  	if (ssrEl) ssrEl.remove()
		}

		this.$store.commit("setScreenType", window.screenSizeManager.screenType);
		window.addEventListener("screenTypeChange", () => {
			this.$store.commit("setScreenType", window.screenSizeManager.screenType);
		});
	},
};
</script>

<style>
.loading-gif {
	width: 150px;
	height: 150px;
}

.shadow-lighter-blue--hover-effect {
	transition: box-shadow 100ms ease-in-out;
}
.shadow-lighter-blue--hover-effect:hover {
	box-shadow: 0px 0px 6px 0px #408caa !important;
}
</style>
